import React from 'react';
import { Typography } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

import {
  MarketoFormComponent,
  MarketoFormComponentProps,
} from '@bizapp-lp/workflow/organisms/MarketoFormComponent';
import { Footer } from '@bizapp-lp/workflow/organisms/Footer';
import { Header, HeaderProps } from '@bizapp-lp/workflow/organisms/Header';

export interface SimpleMarketoFormProps extends MarketoFormComponentProps {
  header?: HeaderProps;
  heading?: React.ReactNode;
  description?: React.ReactNode;
}

const SimpleMarketoForm: React.FC<SimpleMarketoFormProps> = ({
  className,
  header,
  heading,
  description,
  marketoForm,
  children,
}) => {
  const RootContainer = styled('main')(({ theme }) => ({
    backgroundColor: '#F2f3fb',
    padding: '40px 16px 60px',
  }));

  const HeaderBox = styled('header')(({ theme }) => ({
    color: '#333333',
    '& .MuiTypography-h1': {
      fontSize: '32px',
      lineHeight: '48px',
      fontWeight: 'bold',
      textAlign: 'center',
      [theme.breakpoints.down(768)]: {
        fontSize: '24px',
        lineHeight: '36px',
      },
    },
    '& .MuiTypography-body1': {
      fontSize: '14px',
      lineHeight: '21px',
      fontWeight: 'normal',
      textAlign: 'center',
      margin: '16px auto 32px',
    },
  }));

  const FormBox = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
  }));

  return (
    <>
      <Header {...header} />
      <RootContainer className={className}>
        <HeaderBox>
          <Typography variant="h1">{heading}</Typography>
          <Typography variant="body1" component="p">
            {description}
          </Typography>
        </HeaderBox>
        <FormBox>
          <MarketoFormComponent marketoForm={marketoForm}>
            {children}
          </MarketoFormComponent>
        </FormBox>
      </RootContainer>
      <Footer />
    </>
  );
};

export default SimpleMarketoForm;
